/**
* Treatment Plan CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Treatment Plan CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'treatment-plan-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.treatment-plan-cta-top__splide' ).each( function( key, component ) {
        new Splide( component, {
          type: 'loop',
          pagination: false,
          autoWidth: true,
          drag: false,
          gap: '40px',
          arrows: false,
          autoScroll: {
            pauseOnHover: false,
          },
        } ).mount( {AutoScroll} );
      } );

      $( '.treatment-plan-cta-bottom__splide' ).each( function( key, component ) {
        new Splide( component, {
          type: 'loop',
          pagination: false,
          autoWidth: true,
          drag: false,
          gap: '40px',
          arrows: false,
          direction: 'rtl',
          autoScroll: {
            pauseOnHover: false,
          },
        } ).mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'treatment-plan-cta', COMPONENT );
} )( app );
